import { CloseSharp } from "@mui/icons-material";
import { Button, Chip, FormLabel, Grid, Stack } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { subscriptionPayment, triggerAdminWalletPaymentOtp, verifyCompanyPayment } from "../../pages/subscriptions/action";
import Schema from "../../schema";
import NumberInput from "../inputs/normalInput/number";
import { CUSTOM_PAPER_COMPONENT_FOR_AUTO_SUGGEST, FORM_INPUTFIELD_STYLES, FORM_SELECTFIELD_STYLES, hideScrollbarCss, mainGradient } from "../../utils/constant";
import justpayLogo from '../../assets/images/icons/juspaylogo.svg'
import paidIcon from '../../assets/images/icons/paidIcon2.svg'
import { getUserType } from "../../utils/common";
import AutoSuggestion from "../autocomplete";
import { useEffect, useRef, useState } from "react";
import { getAllCompanyforListing } from "../../pages/company/action";
import { updateCompany } from "../../pages/company/companySlice";
import { updateWallet } from "../../pages/wallet/walletSlice";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(0),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(0),
    },
    '& .MuiPaper-root': {
        width: '680px',
        maxWidth: '680px',
        height: '360px',
        border: '0px solid red',
        padding: '40px',
        borderRadius: '16px',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left bottom',
        position: 'relative',
        "&::before": {
            content: '""',
            display: 'block',
            borderRadius: '0px 0px 100px 100px',
            position: 'absolute',
            width: '184px', height: '6px', background: '#22C55E', zIndex: 1, top: '0%', left: '50%', transform: 'translate(-50%)'
        }
    },
}));
export default function AddMoney(props) {
    const { open, setOpen } = props;
    const { listing: companyListing } = useSelector(state => state.companySlice);
    const { sendOtp: showOtpModal } = useSelector(state => state.walletSlice);
    const dispatch = useDispatch();
    const userType = getUserType();
    const [selectedCompanyId, setSelectedCompanyId] = useState("");
    const [validOtp, setValidOtp] = useState(null);
    const [timeLeft, setTimeLeft] = useState(null); // in seconds
    const timerRef = useRef(null);
    const handleClose = () => { setOpen(false); dispatch(updateWallet({ sendOtp: false })); setValidOtp(null) };
    useEffect(() => {
        if (userType === 'admin') {
            dispatch(updateCompany({ limit: 1000, page: 0 }))
            dispatch(getAllCompanyforListing())
        }
    }, [])

    const startTimer = () => {
        setTimeLeft(600);
        if (timerRef.current) clearInterval(timerRef.current);
        timerRef.current = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(timerRef.current);
                    timerRef.current = null;
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    return (
        <>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}>
                <Stack direction="row"
                    justifyContent={"space-between"}
                    paddingBottom={"20px"}
                    alignItems={"center"} >
                    <Stack
                        direction="row"
                        justifyContent={"flex-start"}
                        gap={1}
                        alignItems={"end"}>
                        <Typography sx={{ fontWeight: '500', fontSize: '20px', fontFamily: 'var(--family2) !important', }}>
                            Add Funds
                        </Typography>
                        <Typography fontSize={12} fontWeight={500} color={'#AAA'}>Payments will be process by</Typography>
                        <img src={justpayLogo} alt="justpayLogo" style={{ height: '20px', width: '75px' }} />
                    </Stack>
                    <div className="cursorPointer" onClick={handleClose}>
                        <CloseSharp sx={{ color: "#AAA", fontSize: '20px', fontWeight: '600' }} />
                    </div>
                </Stack>
                <DialogContent className={userType === 'admin' ? "pt-2" : 'pt-3'} sx={{ overflowX:'hidden',overflowY: userType==='admin' && !showOtpModal ? 'scroll':'hidden' }}>
                    <Formik
                        initialValues={{ amount: "", description: "" }}
                        enableReinitialize={true}
                        validateOnChange={true}
                        validationSchema={Schema.BidNegotiate}
                        onSubmit={async (values, { setSubmitting }) => {
                            if (userType !== 'admin') {
                                dispatch(subscriptionPayment({ amount: String(values.amount), type: "" }));
                                setOpen(false);
                            }
                            else {
                                if (showOtpModal) {
                                    const res = await verifyCompanyPayment({ amount: values.amount, companyId: (selectedCompanyId).toString(), otp: (validOtp || '').toString() })
                                    if (res === 'SUCCESS') {
                                        setOpen(false);
                                        setValidOtp(null);
                                        dispatch(updateWallet({ sendOtp: false }));
                                    }
                                }
                                else {
                                    dispatch(triggerAdminWalletPaymentOtp({ amount: values.amount, company: (selectedCompanyId).toString() }, startTimer))
                                }
                            }
                        }}>
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values,
                            setFieldValue,
                            isValid,
                            dirty,
                        }) => {
                            return (
                                <Form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        handleSubmit(e);
                                    }}>
                                    <Grid container spacing={2} >
                                        {showOtpModal ? <>
                                            <Grid item xs={12} lg={12} md={12} sm={12}>
                                                <Typography sx={{ fontSize: '16px', fontWeight: 500, color: '#726C6C', fontFamily: 'var(--family2)', marginBottom: '6px' }}>Enter Otp</Typography>
                                                <NumberInput
                                                    name={"otp"}
                                                    type={"number"}
                                                    focused={false}
                                                    label={("")}
                                                    sizeval="medium"
                                                    values={validOtp}
                                                    onWheel={(e) => e.target.blur()}
                                                    placeholder={"Enter OTP"}
                                                    onChange={(e) => setValidOtp(e.target.value)}
                                                    style={{ ...FORM_INPUTFIELD_STYLES, width: '98%', marginX: '4px', }}
                                                    className="pt-2"
                                                    error={(validOtp || "")?.toString()?.length !== 6 && "Enter Valid OTP"}
                                                />
                                            </Grid>
                                        </> : <> <Grid item xs={12} lg={12} md={12} sm={12}>
                                            <FormLabel required sx={{ fontSize: '16px', fontWeight: 500, color: '#726C6C', fontFamily: 'var(--family2)' }}>Enter Amount(₹)</FormLabel>
                                            <NumberInput
                                                name={"amount"}
                                                type={"number"}
                                                focused={false}
                                                label={("")}
                                                sizeval="medium"
                                                values={values.amount}
                                                onWheel={(e) => e.target.blur()}
                                                placeholder={"Enter Amount(₹)"}
                                                onChange={handleChange}
                                                style={{ ...FORM_INPUTFIELD_STYLES, width: '98%', marginX: '4px', }}
                                                className="pt-2"
                                                error={Boolean(touched.amount) && errors.amount}
                                                helperText={touched.amount && errors.amount}
                                            />
                                            <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} marginTop={"20px"} sx={{marginX:'4px'}}>
                                                {[50000, 100000, 150000, 200000, 300000, 500000].map((item) => (
                                                    <Button sx={{ padding: '8px 12px', borderRadius: '4px', background: values.amount === item ? '#92C5FF80' : '#FAFAFA', color: values.amount === item ? 'var(--color-blue)' : '#726C6C' }} onClick={() => setFieldValue("amount", item)}> <Typography fontSize={12} fontWeight={500}>₹ {item.toLocaleString('en-IN')}</Typography> </Button>
                                                ))}
                                            </Stack>
                                        </Grid>
                                            {userType === 'admin' && <Grid item xs={12} lg={12} md={12} sm={12}>
                                                <Typography sx={{ fontSize: '16px', fontWeight: 500, color: '#726C6C', fontFamily: 'var(--family2)', marginBottom: '6px' }}>Select Company</Typography>
                                                <AutoSuggestion
                                                    sx={{ ...FORM_SELECTFIELD_STYLES, width: '98%', marginX: '4px', }}
                                                    CustomPaperComponent={CUSTOM_PAPER_COMPONENT_FOR_AUTO_SUGGEST}
                                                    multiple={false}
                                                    required={false}
                                                    disableClearable={true}
                                                    className="auto-chips-cover"
                                                    label={""}
                                                    onChange={(e, newValue) => {
                                                        setSelectedCompanyId(newValue.userId)
                                                    }}
                                                    limitTags={1}
                                                    placeholder="Select Company"
                                                    defaultValue={""}
                                                    id={`users-`}
                                                    size="small"
                                                    name="location"
                                                    options={companyListing}
                                                    isOptionEqualToValue={(option, value) => {
                                                        if (value === option)
                                                            return option;
                                                    }}
                                                    getOptionLabel={(option) =>
                                                        option?.companyName || ""
                                                    }
                                                    renderTags={(value, getTagProps) => {
                                                        if (!Array.isArray(value)) return null;
                                                        return value.map((option, index) => {
                                                            return (
                                                                <Chip
                                                                    key={option?.userId || option?.companyName}
                                                                    label={<Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'white' }}>
                                                                        {option?.companyName?.substring(0, 10) || ""}
                                                                    </Typography>}
                                                                    {...getTagProps({ index })}
                                                                    sx={{
                                                                        background: 'black !important',
                                                                        borderRadius: '62px', border: '0px solid #CCCBCB',
                                                                        padding: "3px 8px", height: '32px'
                                                                    }}
                                                                    deleteIcon={<img src={"DeleteIcon"} style={{ filter: 'brightness(0) invert(1)', }} alt="delete icon" width={24} height={24} />} // Custom delete icon
                                                                />
                                                            )
                                                        })
                                                    }
                                                    }
                                                    renderOption={(props, option) => {
                                                        return (
                                                            <>
                                                                <li {...props} style={{
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap', padding: '2px 8px', width: '100%', borderRadius: '0px', border: '0px solid #CCCBCB', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'row', gap: 2
                                                                }}><Typography sx={{ fontSize: '12px', fontWeight: '500', color: '#444141', }}>{option?.companyName}</Typography></li>
                                                            </>)
                                                    }}
                                                />
                                            </Grid>}</>}
                                    </Grid>
                                    <DialogActions>
                                        <Stack direction={"row"} gap={2} mt={4} justifyContent={"center"} alignItems={"end"} width={"100%"}>
                                            <Button sx={{ "&.Mui-disabled": { background: 'rgb(199, 199, 199)' }, background: mainGradient, height: '48px', padding: '12px 24px', borderRadius: '8px' }} disabled={userType === 'admin' ? showOtpModal ? (validOtp || "").toString().length !== 6 : !(isValid && dirty && selectedCompanyId) : !(isValid && dirty)} type="submit"><Stack direction={"row"} gap={1}> <Typography fontSize={16} fontWeight={500} color={"white"}>{userType === 'admin' && !showOtpModal ? "Send Otp" : "Pay now"}</Typography> <img src={paidIcon} alt="paidIcon" style={{ height: '24px', width: '24px' }} /></Stack></Button>
                                            {showOtpModal && <><Button disabled={timerRef.current} onClick={() => {
                                                setValidOtp(null);
                                                dispatch(triggerAdminWalletPaymentOtp({ amount: values.amount, company: (selectedCompanyId).toString() }, startTimer))
                                            }} sx={{ alignItems: 'right', marginTop: '10px', background: 'none', width: 'fit-content', height: 'fit-content', margin: 0, padding: 0, "&:hover": { background: 'none' } }} disableRipple><Typography fontSize={12} fontWeight={400}>Resend OTP</Typography></Button> {timeLeft !== null && (
                                                <Typography fontSize={12} fontWeight={400}>
                                                    Time Left: {Math.floor(timeLeft / 60)}:
                                                    {(timeLeft % 60).toString().padStart(2, "0")}
                                                </Typography>
                                            )}</>}
                                        </Stack>
                                    </DialogActions>
                                </Form>
                            );
                        }}
                    </Formik >
                </DialogContent>
            </BootstrapDialog>
        </>
    );
}
